// The glyph for a task type's or workflow's icon name, on a tinted tile.
import { type Icon, Tag } from "@phosphor-icons/react";

import { cn } from "../ui/cn";
import { ICONS } from "./iconNames";

export function CatalogIcon({ name, fallback = Tag, className }: { name: string | null | undefined; fallback?: Icon; className?: string }) {
  const Glyph = (name && ICONS[name]) || fallback;
  return (
    <span className={cn("flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-lighter text-primary-dark", className)}>
      <Glyph weight="duotone" className="h-5 w-5" aria-hidden />
    </span>
  );
}
